import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Typography, Table, TextField, TableCell, TableContainer, TableBody, TableRow, Box, TableHead } from "@material-ui/core";
import { EventSystemAdminTableHeading } from "../../Utils/appConstants";
import { updateEvents, getEventsList } from "../../service/api";
import Loaderpage from "../../pages/LoaderPage";
import CustomizedInputBase from "../CustomisedInput";

const useStyles = makeStyles({
    table: {
        border: "1px solid #e1e1e1",
    },
    tableRow: {
        borderBottom: "1px solid #e1e1e1",
    },
    tableHeaderRow: {
        borderTop: "1px solid #e1e1e1",
        borderBottom: "1px solid #e1e1e1",
    },
    tableHeadFont: {
        fontWeight: 600,
    },
    root: {
        width: "100%",
    },
    paper: {
        width: "100%",
    },
    eventSystemAdminContianer: {
        display: 'flex',
        flexDirection: 'column'
    },
    tableDataContainer: {
        display: 'flex'
    },
    vinSearchContainer: {
        display: 'flex',
        paddingBottom: '16px'
    },
    actionButton: {
        paddingTop: '16px',
        alignSelf: 'center'
    }
});


const EventSystemAdminComponent = (props) => {
    const classes = useStyles();
    const [vinInput, setVinInput] = React.useState("");
    const [invalidVin, setInvalidVin] = React.useState('');
    const [updateError, setUpdateError] = useState(false);
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const [loader, setLoader] = useState(false);
    const [vinData, setVinData] = React.useState([]);
    const [vin, setVin] = React.useState('');

    let modifiedVinDataList = [];
    const handleSearch = (text) => {
        if (/^[a-zA-Z0-9]*$/.test(text) === false) {
            return setInvalidVin('Please Enter a Valid VIN');
        } else {
            setInvalidVin('');
        }
        setVinInput(text);
    };

    const handleSubmitbtn = async (searchText, submitClck) => {
        const vinSearch = submitClck ? vinInput : searchText;
        if (vinSearch.length < 17) {
            setInvalidVin('Please Enter a Valid 17 Digit VIN');
        }
        if (vinSearch && vinSearch?.length === 17) {
            setVin(vinSearch);
            setLoader(true)
            getEventData(vinSearch);
        }
    };

    const getEventData = async (vinSearch) => {
        const vinDataValue = await getEventsList(vinSearch || vin);
        setLoader(false)
        setVinData(vinDataValue?.data?.eventList);
    }

    const setEventSystemAdminValue = (e, index, id) => {
        vinData?.map((item, indexValue) => {
            if (indexValue === index) {
                item[id] = e.target.value;
                if (modifiedVinDataList.length > 0) {
                    modifiedVinDataList.map((itemData, indexData) => {
                        if (itemData.event_id === item.event_id) {
                            modifiedVinDataList.splice(indexData, 1);
                        }
                        return modifiedVinDataList;
                    })
                    modifiedVinDataList.push(item);
                } else {
                    modifiedVinDataList.push(item);
                }
            }
            return modifiedVinDataList;
        })
    }

    const resetEventListSetting = () => {
        setLoader(true);
        setVinData([])
        getEventData();
        setTimeout(() => {
            setLoader(false)
        }, 200)
    }

    const updateEventListSetting = async () => {
        const body = modifiedVinDataList;
        setLoader(true);
        const updatedAdminSettingValue = await updateEvents(body);
        if (updatedAdminSettingValue?.data?.success === 'TRUE') {
            setLoader(false);
            setUpdateSuccess(true)
            setUpdateError(false);
        } else {
            setLoader(false);
            setUpdateSuccess(false)
            setUpdateError(true);
        }
    }

    return (
        <div className={classes.eventSystemAdminContianer}>
            <div className={classes.vinSearchContainer}>
                <CustomizedInputBase
                    searchdetails={(SearchText) => handleSearch(SearchText)}
                    onEnterKeyDown={(SearchText) => handleSubmitbtn(SearchText)}
                    setInvalidVin={(errorText) => setInvalidVin(errorText)}
                />
                {invalidVin && <Typography style={{ color: 'red' }} component="p">{invalidVin}</Typography>}
                <Button variant="contained" style={{ height: '38px' }} onClick={() => handleSubmitbtn('', true)} color="primary">
                    Submit
                </Button>
            </div>

            <div className={classes.tableDataContainer}>
                {!loader && <TableContainer >
                    <Table className={classes.table} aria-label="simple table">
                        <TableHead className={classes.cellBorder} style={{ backgroundColor: '#dbdbd9' }}>
                            <TableRow>
                                {EventSystemAdminTableHeading?.map((item, index) => {
                                    return (
                                        <TableCell className={classes.cellBorder} component="th" scope="row">
                                            {item?.label}
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {vinData?.map((itemValue, indexValue) => {
                                return (
                                    <TableRow>
                                        {EventSystemAdminTableHeading?.map((item, index) => {
                                            return (
                                                <TableCell className={classes.cellBorder} component="th" scope="row">
                                                    {item?.textField ? <TextField
                                                        className="adminTextContent"
                                                        defaultValue={itemValue[item?.id]}
                                                        label={props.textFieldPlaceHolderText}
                                                        onChange={(e) => {
                                                            setEventSystemAdminValue(e, indexValue, item?.id);
                                                        }}
                                                    /> : itemValue[item?.id]}
                                                </TableCell>
                                            )
                                        })}

                                    </TableRow>
                                )

                            })}
                        </TableBody>
                    </Table>
                </TableContainer>}
            </div>
            <div className={classes.actionButton}>
                {updateError && !updateSuccess && <><div style={{ color: 'red' }}>Please adjust the Changes.</div> <br /></>}
                {updateSuccess && !updateError && <><div style={{ color: '#00C6B7' }}>Successfully Updated the changes.</div> <br /></>}
                <Box display={'flex'}
                    sx={{
                        "& .MuiButton-root": {
                            m: 5
                        }
                    }}>
                    <div style={{ paddingRight: '16px' }}>
                        <Button
                            className={`passButton ${classes.buttonHandle}`}
                            color="primary"
                            onClick={() => resetEventListSetting()}
                        >
                            Cancel
                        </Button>
                    </div>
                    <div>
                        <Button
                            className={`purchaseButton ${classes.buttonHandle}`}
                            color="primary"
                            onClick={() => updateEventListSetting()}
                        >
                            Submit
                        </Button>
                    </div>
                </Box>
            </div>
            <div>
                {loader ? (
                    <Box
                        height={"350px"}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                    >
                        <div>
                            <Loaderpage />
                            <span className="loaderText">Loading...</span>
                        </div>
                    </Box>
                ) : (
                    ""
                )}
            </div>
        </div >

    );
};

export default EventSystemAdminComponent;